export const SITE_ORIGIN = "https://jandsav.com";

// Directory-index pages use trailing slashes. Preserve fragments and queries
// when normalizing a link, but leave relative links and external URLs alone.
export function pagePath(value: string): string {
  if (!value.startsWith("/") || value.startsWith("//")) return value;
  const suffixAt = value.search(/[?#]/);
  const pathname = suffixAt === -1 ? value : value.slice(0, suffixAt);
  const suffix = suffixAt === -1 ? "" : value.slice(suffixAt);
  return `${pathname.replace(/\/+$/, "") || ""}/${suffix}`;
}

export function pageUrl(pathname: string): string {
  return `${SITE_ORIGIN}${pagePath(pathname)}`;
}
